import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import api from "../../../api/api";

import { Typography, Button } from "@mui/material";

//Actions
import { setAlert } from "../../../actions/alert";

//Icons
import { ReactComponent as ShareIcon } from "../../../assets/icons/svg/share.svg";
import { ReactComponent as CopyIcon } from "../../../assets/icons/svg/copy.svg";
import { ReactComponent as ReportIcon } from "../../../assets/icons/svg/report.svg";
import { ReactComponent as BlockIcon } from "../../../assets/icons/svg/block.svg";

const ProfileOptionsModal = ({
  auth: { isAuthenticated, user },
  profile: { viewedProfile, currentProfile },
  handleClose,
  setAlert,
}) => {
  const navigate = useNavigate();

  const [isMyProfile, setIsMyProfile] = useState(
    currentProfile && viewedProfile && currentProfile._id === viewedProfile.id ? true : false
  );

  const [reportLoading, setReportLoading] = useState(false);

  const handleCopyLink = () => {
    const profileLink = `/${viewedProfile && viewedProfile.username ? viewedProfile.username : ""}`;
    navigator.clipboard.writeText(window.location.origin + profileLink);
    setAlert("Link copied to clipboard", "success");
    handleClose();
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: `${viewedProfile && viewedProfile.username ? `@${viewedProfile.username}` : `thisPantry`}`,
          text: `${viewedProfile && viewedProfile.username ? `@${viewedProfile.username} - thisPantry` : `thisPantry`}`,
          url: `/${viewedProfile && viewedProfile.username ? viewedProfile.username : ""}`,
        });
      } catch (error) {
        handleCopyLink();
      }
    } else {
      handleCopyLink();
    }
  };

  const handleBlock = async () => {
    try {
      //Send block request
      const res = await api.post(`/users/block/`, { userid: viewedProfile.id });
      //Set alert
      setAlert(`${viewedProfile.username} has been blocked`, "success");
      //Navigate to home
      navigate("/");
    } catch (error) {
      setAlert("An error occurred. Refresh and try again.", "error");
    }
  };

  const handleReport = async () => {
    setReportLoading(true);
    try {
      await api.post(`/report/profile`, { profileId: viewedProfile.id, reason: "" });
      setReportLoading(false);
      setAlert("Profile reported. Thank you for helping us keep the community safe.", "success");
      handleClose();
    } catch (error) {
      setReportLoading(false);
      if (error.response && error.response.status === 400) {
        setAlert(error.response.data.msg, "warning");
      } else {
        setAlert("Error reporting profile, please refresh and try again.", "error");
      }
    }
  };

  return (
    <div className="flex flex-col align-center justify-center">
      <div className="border-t border-separator">
        <Button
          className="w-full h-12  rounded-none justify-start pl-4"
          onClick={handleShare}
          startIcon={
            <div className="w-8 flex justify-start">
              <ShareIcon className="fill-primaryText h-4" />
            </div>
          }
        >
          <Typography variant="subtitle1" className="font-normal">
            Share Profile
          </Typography>
        </Button>
      </div>
      <div className="border-t border-separator">
        <Button
          className="w-full h-12  rounded-none justify-start pl-4"
          onClick={handleCopyLink}
          startIcon={
            <div className="w-8 flex justify-start">
              <CopyIcon className="fill-primaryText h-4" />
            </div>
          }
        >
          <Typography variant="subtitle1" className="font-normal">
            Copy Link
          </Typography>
        </Button>
      </div>

      {isAuthenticated && !isMyProfile && (
        <>
          <div className="border-t border-separator">
            <Button
              className="w-full h-12 rounded-none justify-start pl-4"
              startIcon={
                <div className="w-8 flex justify-start">
                  <ReportIcon className="fill-red h-4" />
                </div>
              }
              onClick={handleReport}
              disabled={reportLoading}
            >
              <Typography variant="subtitle1" className=" text-normal">
                Report
              </Typography>
            </Button>
          </div>
          <div className="border-t border-separator ">
            <Button
              className="w-full h-12 rounded-none justify-start pl-4"
              startIcon={
                <div className="w-8 flex justify-start">
                  <BlockIcon className="fill-red h-4" />
                </div>
              }
              onClick={handleBlock}
            >
              <Typography variant="subtitle1" className=" text-normal">
                Block
              </Typography>
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

ProfileOptionsModal.propTypes = {
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  setAlert: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
});

export default connect(mapStateToProps, { setAlert })(ProfileOptionsModal);
